import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-front-analysis-page',
  templateUrl: './front-analysis-page.component.html',
  styleUrls: ['./front-analysis-page.component.scss']
})
export class FrontAnalysisPageComponent implements OnInit {

  pageVm$: Observable<any>;

  /**
   *
   */
  constructor(private http: HttpClient) { }

  /**
   *
   */
  ngOnInit(): void {
    // reservations / groups
    const url: string = 'https://empirecls.api.frontapp.com/inboxes/inb_1gqo5/conversations?q=archived';

    // auth
    const authorization: string = 'Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzY29wZXMiOlsic2NpbSIsInByb3Zpc2lvbmluZyIsInByaXZhdGU6KiIsInNoYXJlZDoqIiwidGltOjMwNjg4NSIsInRpbTozMDY5NDkiLCJ0aW06MzA4MTY1IiwidGltOjMwNjA1MyIsInRpbTozMDY2OTMiLCJ0aW06MzA2MTgxIiwidGltOjMwNjgyMSIsInRpbTozMDY3NTciLCJ0aW06MjQ1NTA5IiwidGltOjMwODEwMSJdLCJpYXQiOjE2ODk5NDYwNzgsImlzcyI6ImZyb250Iiwic3ViIjoiZW1waXJlY2xzIiwianRpIjoiMjFkODUyZWZkOTFiMWJhMyJ9.t8BzjgNwOVKHQsmE6qvCGaPCg508JW25OV2NkrhFbBA';

    this.pageVm$ = of({}).pipe(
      switchMap(() => {
        const headers = new HttpHeaders()
          .append('Authorization', authorization)
          .append('Content-Type', 'text/plain');

        return this.http.get<any>(url, { headers: headers });
      }),

      map(results => {
        const v = results;
      }),

      catchError(err => {
        return of({ error: err?.message || err || 'unknown error' })
      })

    );
  }

}
